import { INTERNAL_SAMPLE_CSV, PARTNER_SAMPLE_CSV } from '../constants';
import type { BulkUserType } from '../types';

export function downloadSampleCsv(userType: BulkUserType) {
  const content = userType === 'internal' ? INTERNAL_SAMPLE_CSV : PARTNER_SAMPLE_CSV;
  const filename =
    userType === 'internal' ? 'usuarios-internos-exemplo.csv' : 'usuarios-clientes-exemplo.csv';
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
